import { constants as mediaManagerPanelConsts } from '#packages/mediaManagerPanelInfra';
import constants from '#packages/constants';

const { MEDIA_MANAGER_MEDIA_TYPES } = constants;
export const {
  MEDIA_MANAGER_PANEL_SECTION_ID,
  DYNAMIC_MEDIA_CONTENT_WIDTH,
  SHUTTERSTOCK_MEDIA_TYPE,
} = mediaManagerPanelConsts;

export enum SEARCH_STATUS {
  LOADING = 'LOADING',
  NO_RESULTS = 'NO_RESULTS',
  RESULTS = 'RESULTS',
}

export const SEARCH_ITEMS = [
  {
    id: MEDIA_MANAGER_PANEL_SECTION_ID.WIX_IMAGES,
    mediaType: MEDIA_MANAGER_MEDIA_TYPES.PICTURE,
    automationId: 'addPanel_imageDynamic_wixImagesSection',
  },
  {
    id: MEDIA_MANAGER_PANEL_SECTION_ID.WIX_ILLUSTRATIONS,
    mediaType: MEDIA_MANAGER_MEDIA_TYPES.PICTURE,
    automationId: 'addPanel_imageDynamic_wixIllustrationsSection',
  },
];
